import React, {useState} from 'react'

import TwoOptionModal from "../../../../../atoms/Modals/TwoOptionModal";
import MainTextArea from "../../../../../atoms/Forms/MainTextArea"
import styles from "./RejectModal.module.scss"
import { isMobile } from '../../../../../../../helpers/Mobile';
import i18n from 'i18n';
import { capitalize } from 'helpers/utils/utils_general';

const RejectModal = ({open, handleClose, handleReject}) => {
    const [reason, setreason] = useState('');

    const handleChange = (e) => {
        setreason(e.target.value);
    }

    const handleConfirm = () => {
        handleReject(reason)
        setreason('')
    }

    const handleCloseIntern = () => {
        setreason('')
        handleClose()
    }

    const mwidth = isMobile ? '100% ': '322px';
    const modalContent = <div className={styles["reject-modal-text-area"]} style={{width: mwidth, justifyContent: 'center', display: 'flex'}}>
        <MainTextArea
            label={capitalize(i18n.t("description"))}
            required={false}
            name={'reason'}
            disabled={false}
            handleChange={handleChange}
            value={reason}
        ></MainTextArea>
    </div>
    return(
        <TwoOptionModal open={open} 
            title={i18n.t("reject.order")}
            subtitle={<span style={{fontFamily: 'Ubuntu-Medium', color: '#676F8F'}}>{i18n.t("reject.order.sub")}</span>}
            closeLabel={i18n.t("cancel").toUpperCase()}
            confirmLabel={i18n.t("decline").toUpperCase()}
            handleClose={handleCloseIntern}
            handleConfirm={handleConfirm}
            modalContent={modalContent}
            confirmDisabled={reason.length <= 0}
        ></TwoOptionModal>
    )

}


export default RejectModal